export const defaultFilter = {
    sourceScript: null,
    function: null,
    targetScript: null
};
